'use strict';

const FavoritesStore = require('./FavoritesStore');

class FavoritePageStore extends FavoritesStore {
    constructor(dispatcher) {
        super(dispatcher);

        this._isFetched = {};
        this._isLoading = {};
        this._forceSuccess = {};
    }

    _onFetchStart({ type }) {
        this._error = null;
        this._isLoading[type] = true;
        this.emitChange();
    }

    _onFetchEnd({ type }) {
        this._isFetched[type] = true;
        this._isLoading[type] = false;
        this.emitChange();
    }

    _onForceSuccess({ type, value = false }) {
        this._forceSuccess[type] = value;
        this.emitChange();
    }

    getCollection() {
        return this._collection;
    }

    getFavoriteId(type) {
        const model = this._collection.findWhere({ type });
        let id = null;

        if (model) {
            id = model.get('id');
        }

        return id;
    }

    isSaved(type) {
        const model = this._collection.findWhere({ type });
        return !!model && !model.isNew();
    }

    isFetched(type) {
        return this._isFetched[type] || false;
    }

    isLoading(type) {
        return this._isLoading[type] || false;
    }

    getForceSuccess(type) {
        return this._forceSuccess[type] || false;
    }
}

FavoritePageStore.storeName = 'FavoritePageStore';

FavoritePageStore.handlers = {
    'favoritePage:fetch:start': '_onFetchStart',
    'favoritePage:fetch:end': '_onFetchEnd',
    'favoritePage:error': '_onFavoriteError',

    'favorites:favorite:add': '_onFavoriteAdd',
    'favorites:favorite:remove': '_onFavoriteRemove',

    'favoritePage:forceSuccess': '_onForceSuccess',
    'favorite:canceled': '_onFavoriteCanceled',
};

module.exports = FavoritePageStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/FavoritePageStore.es.js